import fileFormatsTypes from '../@constants/fileFormatsTypes'

export default {
  CHAT_FILE_EXTENSIONS: [
    fileFormatsTypes.JPEG,
    fileFormatsTypes.JPG,
    fileFormatsTypes.HEIC,
    fileFormatsTypes.PNG,
    fileFormatsTypes.PDF,
  ],
  GALLERY_FILE_EXTENSIONS: [
    fileFormatsTypes.JPEG,
    fileFormatsTypes.JPG,
    fileFormatsTypes.HEIC,
    fileFormatsTypes.PNG,
  ],
  TREATMENT_PLAN_EXTENSIONS: [
    fileFormatsTypes.MP4,
    fileFormatsTypes.PDF,
    fileFormatsTypes.JPEG,
    fileFormatsTypes.JPG,
    fileFormatsTypes.PNG,
    fileFormatsTypes.STL,
  ],
  VIDEOS_EXTENSIONS: [
    fileFormatsTypes.MP4,
    fileFormatsTypes.MOV,
    fileFormatsTypes.AVI,
    fileFormatsTypes.MKV,
    fileFormatsTypes.WEBM,
    fileFormatsTypes.FLV,
    fileFormatsTypes.WMV,
    fileFormatsTypes.GP3,
  ],
}
